// Copyright 1999-2018. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-unused-prop-types */

import { createElement } from '../../utils';
import PropTypes from 'prop-types';

/**
 * `Tab` is an individual element of the [Tabs](#!/Tabs) component. A single `Tab` element displays its own unique content when activated.
 * Each `Tab` can display an icon near the tab name for easier identification.
 * `Tab` can also display a [Label](#!/Label) next to the tab name for showing additional information about `Tab` contents.
 * You can make `Tabs` closeable, for example, if you are using `Tabs` for opening and displaying files.
 */
const Tab = ({ children }) => <div>{children}</div>;
Tab.propTypes = {
    /**
     * Tab title
     */
    title: PropTypes.node.isRequired,
    /**
     * Label in tab title
     */
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    /**
     * Name of icon or Icon component for tab
     */
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    /**
     * Activate callback.
     */
    onActivate: PropTypes.func,
    /**
     * Close callback
     */
    onClose: PropTypes.func,
    /**
     * Tab content
     */
    children: PropTypes.node,
};
Tab.defaultProps = {
    label: null,
    icon: null,
    onActivate: null,
    onClose: null,
    children: null,
};

export default Tab;



// WEBPACK FOOTER //
// ./components/Tabs/Tab.js